import { useMutation, useQuery, useQueryClient } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useTasksListViewSettings = (id, config) => {
  return useQuery({
    ...config,
    queryKey: ["project-tasks-list-view-settings", id],
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/projects/${id}/tasks/tasks-list-view-settings`,
        signal,
      }),
  });
};

export const useTasksListViewSettingsMutation = (id) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/projects/${id}/tasks/tasks-list-view-settings`,
        method: "PUT",
        body: data,
      }),
    onSuccess: (response) => {
      queryClient.setQueryData(["project-tasks-list-view-settings", id], response);
    },
  });
};
